import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect, useLocation } from "react-router-dom";
import querystring from "querystring";
import { resetPassword } from "../actions/auth";
import Alert from "./presentational/Alert";
const RecoverPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const { loading, success, error } = useSelector((state) => state.auth.requests.resetPassword);
    const loc = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        if (success) {
            setPassword("");
            setConfirmPassword("");
        }
    }, [success]);
    const recoverPassword = async () => {
        const token = querystring.parse(loc.search.substring(1)).token;
        dispatch(resetPassword.request({ token, password, confirmPassword }));
    };
    if (success) {
        return (React.createElement(Redirect, { to: {
                pathname: "/login",
                state: {
                    alert: {
                        kind: "success",
                        message: "Password reset successfully!"
                    }
                }
            } }));
    }
    return (React.createElement("section", { className: "popup-form" },
        React.createElement("div", { className: "cube-wrap" },
            React.createElement("div", { className: "cube cube-w1" }),
            React.createElement("div", { className: "cube cube-w2" }),
            React.createElement("div", { className: "cube cube-w3" })),
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("div", { className: "col-xl-6 col-lg-8 col-md-10 col-11" },
                    React.createElement("div", { className: "pf_wrap" },
                        React.createElement("div", { className: "pf_title text-c" },
                            React.createElement("h2", null, "Recover Password")),
                        React.createElement(Alert, { kind: "error", className: "pf_input" }, error),
                        React.createElement("form", { className: "pf_form", onSubmit: e => {
                                e.preventDefault();
                                recoverPassword();
                            } },
                            React.createElement("div", { className: "pf_input" },
                                React.createElement("input", { type: "password", placeholder: "New Password", "aria-label": "New Password", value: password, onChange: e => setPassword(e.target.value) })),
                            React.createElement("div", { className: "pf_input" },
                                React.createElement("input", { type: "password", placeholder: "Confirm New Password", "aria-label": "Confirm New Password", value: confirmPassword, onChange: e => setConfirmPassword(e.target.value) })),
                            React.createElement("div", { className: "pf_btn" },
                                React.createElement("button", { type: "submit", className: "btn-blue btn-blue_big", disabled: loading }, "Reset Password")),
                            React.createElement("div", { className: "pf_b-text" },
                                React.createElement("p", null,
                                    "New?",
                                    " ",
                                    React.createElement(Link, { className: "popup-link", to: "/signup" }, "Sign up"),
                                    " ",
                                    "instead.")))))))));
};
export default RecoverPassword;
